var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 2.1c5.468 0 9.9 4.432 9.9 9.9s-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9S6.532 2.1 12 2.1M3.951 12.9a8.1 8.1 0 0 0 6.006 6.939A14.7 14.7 0 0 1 7.549 12.9zm12.5 0a14.7 14.7 0 0 1-2.409 6.939 8.1 8.1 0 0 0 6.007-6.939zm-7.096 0A12.86 12.86 0 0 0 12 19.6a12.86 12.86 0 0 0 2.645-6.7zm4.687-8.74a14.7 14.7 0 0 1 2.41 6.94h3.597a8.105 8.105 0 0 0-6.007-6.94m-4.085 0a8.105 8.105 0 0 0-6.006 6.94H7.55a14.7 14.7 0 0 1 2.408-6.94M12 4.4a12.87 12.87 0 0 0-2.645 6.7h5.29A12.87 12.87 0 0 0 12 4.4"
  })));
};
export default SvgGlobe;